export default "assets/images/icons/slider-arrow-circle-affdcc0a.svg";